import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './BubbleToolTip.less';

export class BubbleToolTip extends Component {
    static propTypes = {
        contents: PropTypes.element.isRequired,
        id: PropTypes.string.isRequired
    };

    render() {
        const { id, contents } = this.props;
        return (
            <div className="BubbleToolTip">
                <div className="tip-hint-wrapper">
                    <div className="tip-hint" role="tooltip">
                        <div id={id} className="tip-text">{contents}</div>
                        <div className="tip-arrow-wrapper">
                            <div className="tip-arrow arrow-1" />
                            <div className="tip-arrow arrow-2" />
                            <div className="tip-arrow arrow-3" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BubbleToolTip;
